import React, { useState } from "react";
import style from "../Header/Header.module.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import api from "../../utils/Api";
import history from "../../utils/history";
import swal from "sweetalert";
import logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";
import { socketDisconnect } from "../../services/SocketServices";
// import ProfileMenu from "../ProfileMenu/ProfileMenu";

function Header(props) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const logout = async () => {
    const token =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).token;
    // Headers
    const headers = {
      Authorization: "Bearer " + token,
    };
    try {
      const response = await api.post("user/logout", {}, { headers: headers });
      if (response.status === 200) {
        localStorage.clear("USER_INFO");
        socketDisconnect();
        history.push("/");
      }
    } catch (e) {
      localStorage.clear("USER_INFO");
      socketDisconnect();
      history.push("/");
      console.log("Error in logout response", e);
    }
  };

  const logoutClick = async () => {
    const shouldLogout = await swal("Are you sure you want to logout?", {
      className: "logout-swal-modal",
      buttons: ["Cancel", "Yes"],
    });
    if (shouldLogout) {
      logout();
    }
  };

  return (
    <React.Fragment>
      <header className={style.headerMainWarapper}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <Navbar expand="md" light className="tech-to-med-navbar">
                <NavbarBrand  className={style.NavbarBrand}>
                  <Link to="/app/dashboard">
                  <img src={logo} className={style.logoImage} alt="TechToMed" />
                  <h1>TechToMedix</h1>
                  </Link>
                </NavbarBrand>
                <NavbarToggler onClick={toggle} className="pull-left" />
                <Collapse isOpen={isOpen} navbar>
                  <Nav className={`ml-auto ${style.techtomedNav}`} navbar>
                    <NavItem>
                      <Link to="/app/dashboard">Home</Link>
                    </NavItem>
                    <NavItem>
                      <Link>Support</Link>
                    </NavItem>
                    <NavItem>
                      <Link>Help</Link>
                    </NavItem>
                  {JSON.parse(localStorage.getItem("USER_INFO")).token && (
                    <NavItem>
                      <Link 
                    onClick={logoutClick}>
                      Logout</Link>
                    </NavItem>
                  )}
                    {/* <NavItem>
                      <NavLink>
                        <img
                          src={profileImage}
                          alt="Avatar"
                          className={style.avatar}
                        />
                        <i
                          className={`fa fa-angle-down ml-2 ${style["profileAngleDown"]}`}
                          aria-hidden="true"
                        ></i>
                      </NavLink>
                    </NavItem> */}
                    {/* <ProfileMenu /> */}
                  </Nav>
                </Collapse>
              </Navbar>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
}
export default Header;
